<template>
  <app-input-text
    ref="input"
    v-model="model"
    :class="optionClass"
    :disabled="computedDisabled"
    :options="transparentOptions"
    @app-event="onAppEvent">
  </app-input-text>
</template>

<script>
/* eslint-disable semi */
import { Component, Watch } from 'vue-property-decorator';
import AppInputComponent from '../input/AppInputComponent';
import AppInputText from '../input/AppInputText';

@Component({
  components: { AppInputText }
})
export default class AppCode extends AppInputComponent {
  // 入力桁数
  get maxlength () {
    if (this.options) {
      if ('padding0' in this.options) {
        return this.options.padding0;
      } else if ('maxLength' in this.options) {
        return this.options.maxLength;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  // 前ゼロ処理有無
  get padding0 () {
    if (this.options) {
      if ('padding0' in this.options) {
        return true;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  get padding0DispOnly () {
    return (this.options && 'padding0DispOnly' in this.options) ? this.options.padding0DispOnly : false;
  }
  get upperCase () {
    return (this.options && 'upperCase' in this.options) ? this.options.upperCase : false;
  }
  get requireTrimTail () {
    return (this.options && 'requireTrimTail' in this.options) ? this.options.requireTrimTail : false;
  }

  data () {
    return {
      innerValue: null
    }
  }

  /**
   * valueが変更された際には内部値として表示・編集用のフォーマットで設定する
   */
  @Watch('value', {immediate: true})
  onValueChange (value) {
    this.innerValue = this.convertToInnerValue(value);
  }

  /**
   * v-model対応
   */
  get model () {
    return this.innerValue;
  }

  /**
   * v-model対応
   */
  set model (value) {
    this.innerValue = value;
  }

  get transparentOptions () {
    // input要素のtypeをurlに設定する
    const options = (this.options) ? this.options : {};
    // urlだとスマホには対応できない（数値入力専用になる問題がある）
    if (!('typeOfInputElement' in options)) {
      options.typeOfInputElement = 'url';
    }
    return options;
  }

  /**
   * 値変更イベント
   */
  onAppEvent (...args) {
    if (args[0] === 'change') {
      // 入力コンポーネントを元の値に一旦戻す
      // 上位コンポーネントでvalueの値が変更された時点で変更後の値に更新される
      this.innerValue = this.convertToInnerValue(this.value);

      // 変更イベントを通知
      const changedValue = this.convertToInnerValue(args[2]);
      const from = this.value;
      const to = this.convertToValue(changedValue);

      this.$emit('input', to);
      this.$emit('app-event', 'change', this, from, to);
      return;
    }
    this.$emit('app-event', ...args);
  }

  /**
   * コード値補正(外部値に変換)
   */
  convertToValue (src) {
    if (src === null || src === undefined || src === '') {
      return null;
    }

    let val = src;

    // 前ゼロ補正が表示のみ（本来のコード値が前ゼロ無し）の場合は前ゼロをクリアする
    if (this.padding0DispOnly && this.padding0) {
      val = val.replace(/^0+/, '');
      // 元々0が入力されている場合は空文字になるので0に補正する
      if (val === '') {
        val = '0';
      }
    }

    return val;
  }

  /**
   * コード値補正(内部値に変換)
   */
  convertToInnerValue (src) {
    // 未設定の場合はnull
    if (src === null || src === undefined) {
      return null;
    }

    // 半角変換
    let val = this.appUtils.toHalfWidth(src);

    // 大文字変換
    if (val !== '' && this.upperCase) {
      val = val.toUpperCase();
    }

    // 末尾の空白削除
    // DBでのCHAR型の桁数と入力用桁数が一致していない場合の為の補正
    if (val !== '' && this.requireTrimTail) {
      val = val.replace(/ +$/, '');
    }

    // 前ゼロ補正
    if (val !== '' && this.padding0) {
      val = ('0000000000' + val).substr(-1 * this.maxlength);
    }

    return val;
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/ex/AppCode.vue